import React from 'react';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import FleetTransactionView from '../../components/FleetTransactionView';
import useRouter from 'hooks/useRouter';

FleetTransactionScreen.propTypes = {};

function FleetTransactionScreen(props) {
    const router = useRouter();
    const agencyId = router.query.agencyId;

    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid p-0">
                <FleetTransactionView agencyId={agencyId} />
            </div>
        </KT01BaseLayout>
    );
}

export default FleetTransactionScreen;
